function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.01009,4.01449h-1.19a2.99225,2.99225,0,0,0-5.32-2.65l-.5.67-.5-.68a2.99319,2.99319,0,0,0-5.32,2.66h-1.18a1.9803,1.9803,0,0,0-1.99,1.98v.02l-.01,11a1.98243,1.98243,0,0,0,1.98,2h14.02a2.00376,2.00376,0,0,0,2-1.99v-11.01A1.99736,1.99736,0,0,0,16.01009,4.01449Zm-10.01-2a1,1,0,1,1-1,1A1.003,1.003,0,0,1,6.00008,2.01449Zm2,15h-6v-6.5h6Zm0-8.5h-6v-2.5h6Zm4-6.5a1,1,0,1,1-1,1A1.003,1.003,0,0,1,12.00008,2.01449Zm-2,4h6v2.5h-6Zm6,11h-6v-6.5h6Z"
});

var SvgIconBonus = function SvgIconBonus(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 18.00008 19.01449",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconBonus, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-bonus.3b9787db.svg";
export { ForwardRef as ReactComponent };